import { MessageCircle, Globe, Users, Calendar, Phone, Mail, Share2, MoreHorizontal, Gavel } from 'lucide-react';

export const ETAPA_CORES = {
  lead: { bg: 'bg-yellow-50', border: 'border-yellow-300', text: 'text-yellow-700', header: 'bg-yellow-100' },
  em_atendimento: { bg: 'bg-blue-50', border: 'border-blue-300', text: 'text-blue-700', header: 'bg-blue-100' },
  proposta_enviada: { bg: 'bg-purple-50', border: 'border-purple-300', text: 'text-purple-700', header: 'bg-purple-100' },
  concluido: { bg: 'bg-green-50', border: 'border-green-300', text: 'text-green-700', header: 'bg-green-100' },
  descartado: { bg: 'bg-red-50', border: 'border-red-300', text: 'text-red-700', header: 'bg-red-100' },
};

export const PRIORIDADE_CONFIG = {
  alta: { label: 'Alta', cor: 'bg-red-100 text-red-700 border-red-200' },
  media: { label: 'Média', cor: 'bg-yellow-100 text-yellow-700 border-yellow-200' },
  baixa: { label: 'Baixa', cor: 'bg-gray-100 text-gray-600 border-gray-200' },
};

export const ORIGEM_ICONES = {
  whatsapp: MessageCircle,
  site: Globe,
  indicacao: Users,
  licitacao: Gavel,
  evento: Calendar,
  telefone: Phone,
  email: Mail,
  redes_sociais: Share2,
  outro: MoreHorizontal,
};

export const MODALIDADES_LICITACAO = [
  { value: 'pregao_eletronico', label: 'Pregão Eletrônico' },
  { value: 'pregao_presencial', label: 'Pregão Presencial' },
  { value: 'concorrencia', label: 'Concorrência' },
  { value: 'tomada_precos', label: 'Tomada de Preços' },
  { value: 'convite', label: 'Convite' },
  { value: 'dispensa', label: 'Dispensa' },
  { value: 'inexigibilidade', label: 'Inexigibilidade' },
];

export const ORIGENS_PRIORIDADE_ALTA = ['whatsapp', 'site', 'redes_sociais'];

export const emptyForm = {
  titulo: '',
  descricao: '',
  cliente_id: '',
  cliente_nome: '',
  contato_nome: '',
  contato_email: '',
  contato_telefone: '',
  contato_codigo_pais: '+55',
  contato_whatsapp: '',
  etapa: 'lead',
  prioridade: 'media',
  valor_estimado: 0,
  probabilidade: 0,
  lead_scoring: {
    orcamento_confirmado: false,
    decisor_identificado: false,
    necessidade_clara: false,
    prazo_definido: false,
    sem_concorrencia: false,
  },
  embarcacoes: [],
  produtos: [],
  anexos: [],
  origem: 'outro',
  origem_detalhe: '',
  indicado_por_cliente_id: '',
  indicado_por_cliente_nome: '',
  licitacao_numero_processo: '',
  licitacao_data_abertura: '',
  licitacao_data_encerramento: '',
  licitacao_modalidade: '',
  responsavel_id: '',
  responsavel_nome: '',
  data_previsao_fechamento: '',
  tags: [],
  observacoes: '',
};
